/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_SUBCATEGORIAS (state, sub_categorias) {
    state.sub_categorias = sub_categorias.data
    state.meta.push(sub_categorias.meta)
  }
}
